export interface SupportContact {
  name: string;
  phone: string;
  phoneRaw: string;
}

export const SUPPORT_CONTACTS: SupportContact[] = [
  { name: 'Nguyễn Công Sơn', phone: '0904.606.545', phoneRaw: '0904606545' },
  { name: 'Lê Minh Tuấn', phone: '0948.089.998', phoneRaw: '0948089998' },
  { name: 'Vũ Minh Ngọc', phone: '0368.688.884', phoneRaw: '0368688884' },
  { name: 'Hà Thị Cẩm Phương', phone: '0974.658.585', phoneRaw: '0974658585' },
  { name: 'Nguyễn Thanh Tùng', phone: '0962.731.888', phoneRaw: '0962731888' },
  { name: 'Võ Tấn Thái', phone: '0869.062.806', phoneRaw: '0869062806' },
];

export const SUPPORT_OFFICE_NOTE =
  'Hoặc liên hệ trực tiếp tại: Trung tâm Công nghệ thông tin - Phòng G104';
